import {getRoadColorByClass} from "../constants/routeColors";
import FARE_VISUALIZATION_TYPES from "../constants/fareVisualizationTypes";
import MyPoint from "./geometry/MyPoint";
import MyPolyline from "./geometry/MyPolyline";
import {Point} from "leaflet/src/geometry";

class PolylineHelper {
    constructor({t}) {
        this.t = t;
    }

    getPolylineTooltip = (roadType) => {
        if ((roadType & FARE_VISUALIZATION_TYPES.common) !== 0) {
            return this.t("trace-common-road-free", "Бесплатная дорога");
        }
        if ((roadType & FARE_VISUALIZATION_TYPES.toll) !== 0) {
            return this.t("trace-common-road-toll", "Платная дорога");
        }
        if ((roadType & FARE_VISUALIZATION_TYPES.platon) !== 0) {
            return this.t("trace-map-route-platon-road-tooltip", "Платон");
        }
        return this.t("trace-common-road-unknown", "Неизвестная дорога");
    };

    mapPointsToPolylines = (visualRoute, platonRate, map) => {
        let key = 0;
        const polylines = [];

        let prevLastPoint = null;
        // Создание коллекции векторов
        for (let i = 0; i < visualRoute.segments.length; i++) {
            const segment = visualRoute.segments[i];
            const fareVisualizationType = segment.fareVisualizationType;
            const hasEmptyRun = (fareVisualizationType & FARE_VISUALIZATION_TYPES.emptyTruck) !== 0;
            const color = getRoadColorByClass(fareVisualizationType);
            const tooltip = this.getPolylineTooltip(fareVisualizationType);
            
            const visibleSubSegments = segment.geoPoints; // Один физический сегмент может быть представлен несколькими "видимыми" сегментами, влезающими в видимую область.
            for (let j = 0; j < visibleSubSegments.length; j++) {
                // visibleSubSegments - коллекция отдельных полилиний 
                const visibleSegmentPoints = visibleSubSegments[j];
                const visibleSegmentPolyline = new MyPolyline(visibleSegmentPoints.map(point => {
                    const coords = map.latLngToContainerPoint(point);
                    return new MyPoint(coords.x, coords.y);
                }));
                const visibleSegmentPolyline_offs = visibleSegmentPolyline.parallel(3);
                const points = visibleSegmentPolyline_offs.Points
                
                // Убираем наложения/пересечения/дырки между стыками линий
                if(prevLastPoint && points.length > 1 && prevLastPoint.distanceTo(points[0]) < 5) {
                    points[0] = prevLastPoint;
                }
                prevLastPoint = points[points.length - 1];
                
                polylines.push({
                    key: key++,
                    positions: points.map(point => map.containerPointToLatLng(new Point(point.x, point.y))),
                    color: color,
                    isDashed: hasEmptyRun,
                    tooltip: tooltip
                })
            }
        }
        return polylines;
    };
}

export default PolylineHelper;
